/** The four tabs of "Verhalten & Fähigkeiten" — shared by the client page
 *  (/agent-setup/<key>) and the agent page (/tutors/:id/setup/<key>). Icons
 *  keep the meanings they have elsewhere in the portal. */
export type AgentSetupTabKey = 'learnings' | 'skills' | 'mcp' | 'moodle' | 'guardrails';

export interface AgentSetupTab {
  key: AgentSetupTabKey;
  titleKey: string;
  icon: string;
  /** client page: only admin/manager (library of a paid / instructing thing) */
  adminOnly: boolean;
  /** agent page: shown when the template carries this setting */
  setting?: string;
  /** only on the agent page — a setting of one agent, nothing to show for
   *  the whole client */
  agentOnly?: boolean;
}

export const AGENT_SETUP_TABS: AgentSetupTab[] = [
  { key: 'learnings', titleKey: 'pages.learnings.title', icon: 'bulb-outline', adminOnly: false, setting: 'agent_learnings_enabled' },
  { key: 'skills', titleKey: 'pages.skills.title', icon: 'book-open-outline', adminOnly: true, setting: 'agent_skills_enabled' },
  { key: 'mcp', titleKey: 'pages.mcp.title', icon: 'link-2-outline', adminOnly: true, setting: 'agent_mcp_enabled' },
  // Moodle-Aktionen (29.09.2026 aus KI-Konfiguration › Funktionen hierher):
  // the AI-configuration section `moodle_actions`, embedded.
  { key: 'moodle', titleKey: 'enums.aiConfigurationTiles.moodle_tools', icon: 'layers-outline', adminOnly: false, setting: 'moodle_tools_enabled', agentOnly: true },
  { key: 'guardrails', titleKey: 'pages.guardrails.title', icon: 'lock-outline', adminOnly: false },
];
